
import "../DropdownBase/DropdownBase.st.css.js";
import "../ListItemAction/ListItemAction.st.css.js";
import "../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_PopoverMenu";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_PopoverMenu__root","listItem":"wds_1_182_0_PopoverMenu__listItem"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-popover-menu-paddings-vertical":"--wds-popover-menu-paddings-vertical","wds-popover-menu-paddings-horizontal":"--wds-popover-menu-paddings-horizontal"}; 




